import { isRequestError } from '@utils/requests';

import * as applications from './applications';
import * as authentication from './authentication';
import * as companies from './companies/requests';
import * as departments from './departments/requests';
import * as integrations from './integrations';
import * as jobboards from './jobboards';
import * as jobs from './jobs/requests';
import * as locations from './locations/requests';
import * as messages from './messages';
import * as notifications from './notifications/requests';
import { request } from './request';
import * as seasonalTheme from './seasonal-theme';
import * as templates from './templates/requests';
import * as users from './users';

export const api = {
  authentication,
  applications,
  companies,
  departments,
  integrations,
  jobs,
  jobboards,
  locations,
  messages,
  notifications,
  templates,
  users,
  seasonalTheme,

  global: {
    isRequestError,
    ...request,
  },
};

export { request };
